import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SDKProvider } from './context/SDKContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import RequireAuth from './components/auth/RequireAuth.tsx';
import PublicLayout from './components/layout/PublicLayout.tsx';
import LoginPage from './pages/LoginPage.tsx';
import ChatPage from './pages/ChatPage.tsx';
import ClauseBenefPage from './pages/ClauseBenefPage.tsx';

export default function AppPublic(): React.ReactElement {
  return (
    <SDKProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              element={
                <RequireAuth>
                  <PublicLayout />
                </RequireAuth>
              }
            >
              {/* Le chat principal */}
              <Route path="chat" element={<ChatPage />} />
              <Route path="clause-beneficiary" element={<ClauseBenefPage />} />
              {/* Redirections par défaut */}
              <Route path="" element={<Navigate to="/chat" replace />} />
            </Route>

            <Route path="*" element={<Navigate to="/chat" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SDKProvider>
  );
}
